
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/Button';

import error_img from '../../assets/images/error.svg'
import TitleH1 from '../../components/TitleH1';
import { useDispatch, useSelector } from 'react-redux';
import { selectTranslations } from '../../services/i18n/i18nSlice';
import { loadUserProfileData, selectUserData } from '../../features/User/userSlice';
import { fetchImpersonateUser } from '../SuperAdminScreen/SuperAdminApi';
import { TENANT } from '../../config/constants';
import { setLoading } from '../../services/global/globalSlice';
import Text from '../../components/Text';


export default function NoAccessScreen (props) {

    const t = useSelector(selectTranslations);
    const userData = useSelector(selectUserData);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const resetImpersonification = async () => {
        dispatch(setLoading(true))
        const response = await fetchImpersonateUser(TENANT,null)
        if(response.success){
            await dispatch(loadUserProfileData())
            navigate('/super_admin', { replace: true })
        }
        dispatch(setLoading(false))
    }

    return(
        <div id="errorScreen">
            <div className="h-100 d-flex flex-column align-items-center justify-content-between justify-content-md-center">
                <div className="top pt-5 pt-md-0">
                    <div className='row align-items-center'>
                        <div className='col-12 col-md-6'>
                            <img src={error_img} className="w-100 px-5 mx-auto d-block" style={{maxWidth:'400px'}} />
                        </div>
                        <div className='col-12 col-md-6'>
                            <TitleH1 className="text-center text-md-start mt-2">{props?.error_title ? props?.error_title : t.error.error_page_title}</TitleH1>
                            <Text className="text-center text-md-start mt-2">{props?.error_text ? props?.error_text : t.error.error_page_text}</Text>
                            {userData?.is_super_admin ?
                                <Button type={'primary'} className="mt-3 mx-auto mx-md-0" onClick={resetImpersonification}>{t.super_admin.reset_impersonation}</Button>
                            :
                                <Link to={'/'}>
                                    <Button type={'primary'} className="mt-3 mx-auto mx-md-0">{t.buttons.back_home}</Button>
                                </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}